// Query kalitlari — bitta joyda, aks holda bir xil ma'lumot ikki xil kalit
// ostida keshlanib, biri yangilanganda ikkinchisi eskirib qoladi.
export const queryKeys = {
  me: ['selfcare', 'me'] as const,
  balance: ['selfcare', 'balance'] as const,
  usage: ['selfcare', 'usage'] as const,
  sessions: ['selfcare', 'sessions'] as const,
  /**
   * ⚠️ TIL KALIT ICHIDA. Paket nomi serverda tanlangan tilda keladi
   * (`fetchPlans`), ya'ni `ru` va `uz` javoblari BOSHQA-BOSHQA. Bitta
   * kalit ostida keshlansa, abonent tilni almashtirganda ekranda eski
   * tildagi nomlar qolib ketardi — so'rov qayta yuborilmaydi, xato ham
   * yo'q. Faqat yangilanmagan ekran.
   */
  plans: (lang: string) => ['selfcare', 'plans', lang] as const,
  historyAll: ['selfcare', 'history'] as const,
  history: (from: string, to: string) => ['selfcare', 'history', from, to] as const,
}
